{
  "blocks": [
    {
      "id": "dx-male-factor-infertility",
      "kind": "condition",
      "tags": ["his", "sperm", "semen-analysis", "evidence-based"],
      "title": "Male factor infertility",
      "subtitle": "Abnormal sperm parameters affecting conception",
      "body": {
        "conditionName": "Male factor infertility",
        "category": "male-factor",
        "description": "Male factor infertility encompasses a range of conditions where abnormal sperm count, motility, or morphology reduces the likelihood of natural conception. It is a contributing factor in approximately 50% of couples experiencing infertility. Causes include varicocele, hormonal imbalances, genetic factors, lifestyle, and idiopathic (unknown) origins.",
        "symptoms": [
          "Usually no physical symptoms",
          "Difficulty conceiving",
          "History of testicular injury, surgery, or infection",
          "Erectile or ejaculatory dysfunction (in some cases)"
        ],
        "howDiagnosed": "Primary diagnosis is through semen analysis measuring volume, concentration, motility, and morphology (WHO 2021 criteria). Additional tests may include hormonal panel (FSH, testosterone, LH), scrotal ultrasound, DNA fragmentation testing, and genetic screening (karyotype, Y-chromosome microdeletion).",
        "impactOnFertility": "Impact varies widely based on severity. Mild abnormalities may be overcome with IUI. Moderate abnormalities typically require IVF. Severe cases (very low count or motility) require IVF with ICSI, where a single sperm is injected directly into the egg.",
        "prevalence": "Contributes to infertility in approximately 40–50% of couples. Purely male factor accounts for about 20–30%.",
        "treatmentOptions": [
          "IUI (for mild abnormalities)",
          "IVF with ICSI (for moderate to severe cases)",
          "Varicocele repair (if varicocele present)",
          "Hormonal treatment (clomiphene, hCG, or FSH for hormonal causes)",
          "Lifestyle modifications (reduce heat exposure, quit smoking, limit alcohol)",
          "Surgical sperm retrieval (TESA/micro-TESE for azoospermia)",
          "Antioxidant supplementation (CoQ10, vitamin E, zinc)"
        ],
        "prognosis": "Prognosis is generally good with appropriate treatment selection. IVF-ICSI achieves fertilization rates of 60–70% per egg regardless of sperm parameters. Lifestyle changes can improve sperm quality over 2–3 months (one spermatogenesis cycle).",
        "forWhom": "him"
      },
      "sources": [
        {
          "title": "Diagnosis and Treatment of Infertility in Men: AUA/ASRM Guideline",
          "authors": "Schlegel PN, Sigman M, Collura B, et al.",
          "journal": "Journal of Urology",
          "year": 2020,
          "url": "https://www.asrm.org/practice-guidance/practice-committee-documents/diagnosis-and-treatment-of-infertility-in-men-auaasrm-guideline-part-i-2020/",
          "evidenceLevel": "guideline"
        },
        {
          "title": "WHO Laboratory Manual for the Examination and Processing of Human Semen, 6th Edition",
          "authors": "World Health Organization",
          "journal": "WHO Publications",
          "year": 2021,
          "url": "https://www.who.int/publications/i/item/9789240030787",
          "evidenceLevel": "guideline"
        }
      ]
    },
    {
      "id": "dx-azoospermia",
      "kind": "condition",
      "tags": ["his", "sperm", "semen-analysis", "evidence-based"],
      "title": "Azoospermia",
      "subtitle": "No sperm found in the ejaculate",
      "body": {
        "conditionName": "Azoospermia",
        "category": "male-factor",
        "description": "Azoospermia means no sperm are found in the semen after centrifugation. It's classified as obstructive (sperm are produced but blocked) or non-obstructive (impaired sperm production). Obstructive causes include vasectomy, congenital absence of the vas deferens, or post-infection scarring. Non-obstructive causes include genetic conditions, hormonal disorders, or testicular failure.",
        "symptoms": [
          "Inability to conceive",
          "Normal ejaculation in most cases",
          "Small or undescended testes (in some non-obstructive cases)",
          "History of vasectomy or groin surgery"
        ],
        "howDiagnosed": "Confirmed by two semen analyses showing zero sperm. Blood tests (FSH, testosterone, LH) help differentiate obstructive from non-obstructive. Genetic testing (karyotype, CFTR mutations, Y-microdeletion) is recommended. Testicular ultrasound assesses testicular volume and structure.",
        "impactOnFertility": "Natural conception is not possible. However, sperm can often be surgically retrieved for IVF-ICSI. Obstructive azoospermia has the best prognosis: sperm are usually found. Non-obstructive cases have variable sperm retrieval rates.",
        "prevalence": "Affects 1% of all men and 10–15% of infertile men.",
        "treatmentOptions": [
          "Micro-TESE (microsurgical testicular sperm extraction), gold standard for non-obstructive",
          "TESA or PESA (for obstructive causes)",
          "Vasectomy reversal (if applicable)",
          "IVF-ICSI with surgically retrieved sperm",
          "Donor sperm (if no sperm can be retrieved)",
          "Hormonal therapy (for select non-obstructive cases)"
        ],
        "prognosis": "Obstructive azoospermia: sperm retrieval rates > 95%. Non-obstructive: micro-TESE finds sperm in 40–60% of cases. When sperm are found, ICSI fertilization and pregnancy rates are comparable to other male factor causes.",
        "forWhom": "him"
      },
      "sources": [
        {
          "title": "Diagnosis and Treatment of Infertility in Men: AUA/ASRM Guideline",
          "authors": "Schlegel PN, Sigman M, Collura B, et al.",
          "journal": "Journal of Urology",
          "year": 2020,
          "url": "https://www.asrm.org/practice-guidance/practice-committee-documents/diagnosis-and-treatment-of-infertility-in-men-auaasrm-guideline-part-i-2020/",
          "evidenceLevel": "guideline"
        }
      ]
    }
  ],
  "relationships": [],
  "localeVariants": []
}
